import { Component } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, NotificationTemplate } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-template-grid',
    templateUrl: './notification-template-grid.component.html',
    styleUrls: ['./notification-template-grid.component.scss']
})
export class NotificationTemplateGridComponent extends BaseGridComponent<NotificationTemplate, BaseState> {
    constructor(A: ServiceBagService) {
        super(A, 'NotificationTemplateGridComponent', NotificationTemplate, BaseState);
    }

    OnNavigate(e) {
        this.Navigate(['/pages/general/notification-template', e.data.EntryID]);
    }
}
